import { render, staticRenderFns } from "./KintaiLocalHeader.vue?vue&type=template&id=20472fc7&scoped=true&"
import script from "./KintaiLocalHeader.vue?vue&type=script&lang=ts&"
export * from "./KintaiLocalHeader.vue?vue&type=script&lang=ts&"
import style0 from "./KintaiLocalHeader.vue?vue&type=style&index=0&id=20472fc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20472fc7",
  null
  
)

export default component.exports